/**
 * @generated SignedSource<<2286f565cf8733546cb82c13bd547dc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountDetailsFragment$data = {
  readonly website: string | null;
  readonly urls: any | null;
  readonly description: string | null;
  readonly phone: string | null;
  readonly businessLogoUrls: any | null;
  readonly coverPhotoUrls: any | null;
  readonly " $fragmentType": "accountDetailsFragment";
};
export type accountDetailsFragment$key = {
  readonly " $data"?: accountDetailsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountDetailsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountDetailsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urls",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "businessLogoUrls",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverPhotoUrls",
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "ac998a43339bdb66098c69ffc088b286";

export default node;
